<template>
    <v-container fluid>
        <v-row no-gutters class="mb-2">
            <v-btn small link class="ma-2" @click="exportXLS()">{{ $t("page.events.registration.xls") }}</v-btn>
            <v-btn small link class="ma-2" @click="exportCVS()">{{ $t("page.events.registration.cvs") }}</v-btn>
            <v-btn small link class="ma-2" @click="exportPDF()">{{ $t("page.events.registration.pdf") }}</v-btn>
        </v-row>
        <v-row class="my-2">
            <v-col xs="12" sm="2" md="2" lg="2" xl="2" class="pt-0 text-left">
                {{ $t('common.completed') }}: {{ completed }}
            </v-col>
            <v-col xs="12" sm="2" md="2" lg="2" xl="2" class="pt-0 text-left">
                {{ $t('common.inPayment') }}: {{ inPayment }}
            </v-col>
            <v-col xs="12" sm="2" md="2" lg="2" xl="2" class="pt-0 text-left">
                {{ $t('common.unconfirmed') }}: {{ unconfirmed }}
            </v-col>
            <v-col xs="12" sm="2" md="2" lg="2" xl="2" class="pt-0 text-left">
                {{ $t('common.canceled') }}: {{ canceled }}
            </v-col>
            <v-col xs="12" sm="2" md="2" lg="2" xl="2" class="pt-0 text-left">
                {{ $t('common.failed') }}: {{ failed }}
            </v-col>
            <v-col cols="12" class="pt-0">
                <VueTabulator ref="tabulator" v-model="practiceRegistrants" :options="tabulatorOptions" />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>

export default {
    props: {
        practiceRegistrants: {
            type: Array,
            default: null
        },
    },
    computed: {
        tabulatorOptions: function ()
        {
            return {
                placeholder: this.$t("page.events.tabulator.noRegistrantsYet"),
                height: '600px',
                printAsHtml: true,
                layout: "fitDataFill",
                responsiveLayout: false,
                initialSort: [
                    { column: "firstName", dir: "asc", }
                ],
                columns: [
                    {
                        title: this.$t("page.events.tabulator.first-name"),
                        field: "firstName",
                        sorter: "string",
                        width: 200,
                        headerFilter: "input",
                        headerFilterPlaceholder: " ",
                    },
                    {
                        title: this.$t("page.events.tabulator.last-name"),
                        field: "lastName",
                        sorter: "string",
                        width: 200,
                        headerFilter: "input",
                        headerFilterPlaceholder: " ",
                    },
                    {
                        title: this.$t("page.events.tabulator.phone-number"),
                        field: "phone",
                        sorter: "string",
                        width: 150,
                        headerFilter: "input",
                        headerFilterPlaceholder: " ",
                    },
                    {
                        title: this.$t("page.events.tabulator.date-birth"),
                        field: "birthDate",
                        sorter: "string",
                        width: 150,
                        headerFilter: "input",
                        headerFilterPlaceholder: " ",
                    },
                    {
                        title: this.$t("page.events.tabulator.registered-by"),
                        field: "registeredBy",
                        sorter: "string",
                        width: 150,
                        headerFilter: "input",
                        headerFilterPlaceholder: " ",
                    },
                    {
                        title: this.$t("page.events.tabulator.status"),
                        field: "status",
                        sorter: "string",
                        width: 150,
                        headerFilter: "input",
                        headerFilterPlaceholder: " ",
                        formatter: function (cell) {
                            let value = cell.getValue();
                            return value ? this.$t(`common.${value}`) : '';
                        }.bind(this)                    
                    },
                    {
                        title: this.$t("page.events.tabulator.created_date"),
                        field: "created_at",
                        sorter: "string",
                        width: 150,
                        headerFilter: "input",
                        headerFilterPlaceholder: " ",
                    }
                ]
            };
        },
        completed()
        {
            return this.practiceRegistrants.filter(pr => pr.status === 'completed').length;
        },
        inPayment()
        {
            return this.practiceRegistrants.filter(pr => pr.status === 'inPayment').length;
        },
        unconfirmed()
        {
            return this.practiceRegistrants.filter(pr => pr.status === 'unconfirmed').length;
        },
        canceled()
        {
            return this.practiceRegistrants.filter(pr => pr.status === 'canceled').length;
        },
        failed()
        {
            return this.practiceRegistrants.filter(pr => pr.status === 'failed').length;
        },
    },
    methods: {
        exportXLS()
        {
            const tabulatorInstance = this.$refs.tabulator.getInstance();
            tabulatorInstance.downloadToTab("xlsx", "data.xlsx");
        },
        exportCVS()
        {
            const tabulatorInstance = this.$refs.tabulator.getInstance();
            tabulatorInstance.downloadToTab("csv", "data.csv");
        },
        exportPDF()
        {
            const tabulatorInstance = this.$refs.tabulator.getInstance();
            tabulatorInstance.downloadToTab("pdf", "pdf.csv");
        }
    }
}
</script>